// HazardMarks - the warning mark on each figure a template would catch (blast, cone, beam, arc, spawn).
import type { Camera } from '../engine/battlefield/projection';
import { project, SCENE_VIEW } from '../engine/battlefield/projection';
import styles from '../styles/Battlefield.module.css';

/**
 * A hazard mark on each caught figure. Under perspective a figure behind the eye is not drawn (BattlefieldTokens),
 * so it gets no mark either: projected, it would land at a mirrored spot and give the figure away (2026-11-01).
 */
export function CaughtMarks({
  at,
  camera,
  testId,
  avoid,
}: {
  at: readonly { x: number; z: number }[] | undefined;
  camera: Camera;
  testId: string;
  avoid?: string | null;
}) {
  const marks = (at ?? []).map((one) => project({ x: one.x, y: 0.04, z: one.z }, camera, SCENE_VIEW));
  return marks.map((p, i) => (p.behind ? null : <HazardMark key={i} x={p.x} y={p.y} testId={testId} avoid={avoid} />));
}

/** The warning mark itself: a triangle over ground tape, with the victim's avoid test under it when there is one. */
export function HazardMark({ x, y, testId, avoid }: { x: number; y: number; testId: string; avoid?: string | null }) {
  return (
    <g className={styles.blastCaught} data-testid={testId} transform={`translate(${x.toFixed(1)},${y.toFixed(1)})`}>
      {/* Their avoid test before the shot (T2, the areas page): the characteristic and what a pass buys. */}
      {avoid && (
        <text className={styles.avoidChip} data-testid="avoid-chip" y={23} textAnchor="middle">
          {avoid}
        </text>
      )}
      {/* The grill: three bars, widest at the front, reading as ground tape. */}
      <line x1={-9} y1={5} x2={9} y2={5} />
      <line x1={-7} y1={8} x2={7} y2={8} />
      <line x1={-4} y1={11} x2={4} y2={11} />
      {/* The triangle, point up, with its bar. */}
      <path d="M 0 -11 L 9 3 L -9 3 Z" />
      <line x1={0} y1={-6} x2={0} y2={-1} />
      <line x1={0} y1={1} x2={0} y2={1.5} />
    </g>
  );
}
